import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { TokenService } from "src/app/auth/token.service";
import { UserService } from "src/app/auth/user.service";

@Component({
  selector: "app-user-info",
  templateUrl: "./user-info.component.html",
  styleUrls: ["./user-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInfoComponent {
  get name() {
    return `${this._tokenService.getPayloadAttribute(
      "firstName"
    )} ${this._tokenService.getPayloadAttribute("lastName")}`;
  }

  get roles() {
    return this._tokenService.getRoles().join(", ");
  }

  constructor(
    private _tokenService: TokenService,
    private _userService: UserService,
    private authService: MsalService
  ) {}

  logout() {
    this.authService.logout();
    this._userService.logout();
    sessionStorage.clear();
    localStorage.clear();
  }
}
